import { Box, makeStyles, Typography } from '@material-ui/core';
import React, { ReactNode } from 'react';

import { CONSTANTS } from '../../../../../../../core/config/constants';
import { FontSizes } from '../../../../../../../core/config/mainTheme';
import { capitalizeFirstLetter } from '../../../../../../../core/utils/string.utils';

interface Props {
  label: string;
  value?: any[];
  children?: ReactNode;
}

const IndustryCodeContentBlock: React.FC<Props> = ({ label, value, children }) => {
  const classes = useStyles();

  return (
    <>
      <Box className={classes.label}>{label}</Box>
      {value?.length ? (
        value.map((item: any, index: number) => {
          const industryKeys = Object.keys(item);
          return (
            <Box className={classes.value} key={index}>
              <Typography>
                <span className={classes.bold}>{item[industryKeys[0]]}</span>
                {' - '}
                {capitalizeFirstLetter(item[industryKeys[1]])}
              </Typography>
            </Box>
          );
        })
      ) : (
        <Box className={classes.value}>{CONSTANTS.EMPTY_VALUE}</Box>
      )}

      {children}
    </>
  );
};
const useStyles = makeStyles((theme) => ({
  label: {
    textTransform: 'uppercase',
    fontSize: FontSizes.size.small,
    color: theme.palette.grey[500],
  },
  value: {
    fontSize: FontSizes.size.medium,
    color: theme.palette.grey[900],
  },
  bold: {
    fontWeight: FontSizes.fontWeight.bold,
  },
}));

export default IndustryCodeContentBlock;
